import JSONAPIClient from '../JSONAPIClient'

JSONAPIClient.define('closing_task_item', {
  user_id: '',
  preview_status: '',
  esigning_status: '',
  url: '',
})
